module.exports = __webpack_public_path__ + "img/mentors.acfaa524.png";